import { render, staticRenderFns } from "./SendMessageForm.vue?vue&type=template&id=5d9d85d0&scoped=true&lang=pug"
import script from "./SendMessageForm.vue?vue&type=script&lang=ts"
export * from "./SendMessageForm.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageForm.vue?vue&type=style&index=0&id=5d9d85d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d85d0",
  null
  
)

export default component.exports